import consumer from "./consumer"

export function subscribeToDocumentClassifier(callbacks = {}) {
  return consumer.subscriptions.create(
    { channel: "DocumentClassifierChannel" },
    {
      received(data) {
        console.log("DocumentClassifier update:", data)
        callbacks.received?.(data)
      },

      connected() {
        callbacks.connected?.()
      },

      disconnected() {
        callbacks.disconnected?.()
      }
    }
  )
}

